<template>
    <div class="banner_09m">
        <div class="swiper-container">
            <div class="swiper-wrapper" >
                <div class="swiper-slide" v-for="(item, index) in bannerImgs" :key="index">
                    <video v-if="item.type=='video'" width="100%"  controls="controls" autoplay="true">
                        <source :src="`${baseUrl}img/video/video5.mp4`" type="video/mp4" />
                    </video>
                    <img v-else :src="baseUrl+item.src"/>
                </div>
            </div>
        </div>
        <div class="selectList">
            <div @click="setIndex(index)" :class="`items ${indexs==index?'items_select':'items_unselect'}`" v-for="(item, index) in bannerImgs" :key="index+20"></div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            bannerImgs:[
                // {src:"video5",type:'video'},
                {src:"img/banner0_09m.png"},
                {src:"img/banner1_09m.png"},
                {src:"img/banner2_09m.png"}            
            ],
            indexs:0,
            mySwiper:{}
        }
    },
    methods:{
        setIndex(i){
            this.mySwiper.slideTo(i+1, 500, false);//切换到第一个slide，速度为1秒
        }
    },
    mounted(){
        let _this = this
        this.mySwiper = new Swiper('.swiper-container',{
            loop:true,
            grabCursor: true,
            paginationClickable: true,
            autoplay: true,
            on:{
                transitionEnd: function(swiper){
                    _this.indexs = swiper.realIndex
                },
            },
        });
        this.timer = setInterval(()=>{
           this.mySwiper.slideNext();
        },5000)
    },
    destroyed(){
        clearInterval(this.mySwiper)
    }
}
</script>

<style lang="less" scope>
.banner_09m{
    @height:35vw;
    width: 100vw;
    height: fit-content;
    overflow: hidden;
    position: relative;
    .selectList{
        position: absolute;
        left: 50%;
        bottom: 0%;
        transform: translate(-50%,0);
        display: flex;
        align-items: center;
        z-index: 1000;
        .items{
            width:0.5vw;
            height:0.5vw;   
            border-radius: 50%;
            border: 2px solid #FFFFFF; 
            margin: 1vw 0.6vw; 
            cursor: pointer;    
        }
        .items_select{
            background-color: #009D40;                        
        }
        .items_unselect{
            background-color: #D8D8D8;            
        }
    }
    .swiper-slide {
        width: 100%;
        // height: @height;
    }

    .swiper-slide  img {
        width:100%;
        // height: 100%;
    }
}
</style>

